/* Amaxa — попап знижки 10% (email) + плаваюча іконка. Показ: 1 раз за сесію,
   а після того як email вже відправлено (код отримано) — назавжди, на будь-яких
   сесіях (localStorage), ні попап, ні іконка більше не показуються. */
(function () {
  var STORAGE_KEY = 'amx_discount_popup_seen';
  var CLAIMED_KEY = 'amx_discount_popup_claimed';

  function init(root) {
    var overlay = root.querySelector('#amxpOverlay');
    var fab = root.querySelector('#amxpFab');
    var body = root.querySelector('#amxpBody');
    var done = root.querySelector('#amxpDone');
    if (!overlay || !fab) return;
    if (window.lucide) lucide.createIcons();

    // Сабміт іде через fetch (без переходу сторінки): коли на сторінці є ще одна
    // форма типу 'customer' (напр. підписка у футері), Shopify-редірект на return_to
    // ненадійний — САМ Shopify переписує query-рядок на свій "?customer_posted=true",
    // ігноруючи наш параметр, через що визначити "форму щойно відправлено" після
    // перезавантаження неможливо і попап відкривається знову як порожній. Замість
    // цього показуємо стан "Дякуємо" одразу на клієнті, без перезавантаження сторінки.
    var form = root.querySelector('#AmxPopupForm');
    var endpoint = root.dataset.discountEndpoint;
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[name="contact[email]"]');
        var email = emailInput && emailInput.value.trim();
        if (!email) return;

        if (endpoint) {
          try {
            var blob = new Blob([JSON.stringify({ action: 'popup_discount', email: email })], { type: 'text/plain' });
            navigator.sendBeacon(endpoint, blob);
          } catch (e) {}
        }

        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
          .catch(function () {})
          .finally(function () {
            body.hidden = true;
            done.hidden = false;
            markSeen();
            markClaimed();
          });
      });
    }

    function open() {
      body.hidden = false;
      done.hidden = true;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (window.lucide) lucide.createIcons();
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (!claimed) fab.hidden = false;
      if (window.lucide) lucide.createIcons();
    }
    function markSeen() {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    function markClaimed() {
      claimed = true;
      try { localStorage.setItem(CLAIMED_KEY, '1'); } catch (e) {}
    }

    [].slice.call(overlay.querySelectorAll('[data-amxp-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    fab.addEventListener('click', open);

    var claimed;
    try { claimed = !!localStorage.getItem(CLAIMED_KEY); } catch (e) { claimed = false; }

    if (claimed) {
      // email вже відправлено раніше (код отримано) — ні попап, ні іконка більше не показуються
      return;
    }

    var seen;
    try { seen = sessionStorage.getItem(STORAGE_KEY); } catch (e) { seen = null; }

    if (seen) {
      fab.hidden = false;
      return;
    }

    var delay = (parseFloat(root.dataset.delay) || 2) * 1000;
    setTimeout(function () {
      markSeen();
      open();
    }, delay);
  }

  function boot() {
    var root = document.querySelector('[data-amxp]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
